module.exports = __webpack_public_path__ + "img/id_get.65484d9.png";